import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { Api } from "../../services/api";

declare var WeixinJSBridge;

@IonicPage({
  segment: "dtbpay/:db/:id/:returl",
})
@Component({
  selector: "page-dtb-pay",
  templateUrl: "dtb-pay.html",
})
export class DtbPayPage {
  JSON = JSON;

  data = {
    order: null,
    orderPaid: false,
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private api: Api
  ) {}

  ionViewDidEnter() {
    document.title = "订单支付";
    this.api.doDtbPay(this.navParams.data).then((orderInfo) => {
      this.data.order = orderInfo;
      const onWeixinPayOk = () => {
        this.data.orderPaid = true;
        setTimeout(() => {
          if (this.navParams.data.returl) {
            const decodedReturl = urlSafeBase64Decode(
              this.navParams.data.returl
            );
            if (decodedReturl != "nop") {
              window.location.href = decodedReturl;
            }
          }
        }, 1000);
      };

      const onBridgeReady = () => {
        WeixinJSBridge.invoke("getBrandWCPayRequest", orderInfo, (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            onWeixinPayOk();
          } else {
            alert(JSON.stringify(res));
          }
        });
      };

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        }
      } else {
        onBridgeReady();
      }
    });
  }

  ionViewDidLoad() {}
}

function urlSafeBase64Decode(value) {
  return atob(
    value.split(".").join("=").split("-").join("/").split("_").join("+")
  );
}

function urlSafeBase64Encode(value) {
  return btoa(value)
    .split("=")
    .join(".")
    .split("/")
    .join("-")
    .split("+")
    .join("_");
}



// WEBPACK FOOTER //
// ./src/pages/dtb-pay/dtb-pay.ts